export const DATA = [
	{
		id: 1,
		time: "Wednesday, Dec 10",
		location: "New York",
		items: [
			{
				id: 1.1,
				photo: "1",
			},
			{
				id: 1.2,
				photo: "2",
			},
			{
				id: 1.3,
				photo: "3",
			},
			{
				id: 1.4,
				photo: "4",
			},
			{
				id: 1.5,
				photo: "5",
			},
			{
				id: 1.6,
				photo: "6",
			},
			{
				id: 1.7,
				photo: "7",
			},
			{
				id: 1.8,
				photo: "8",
			},
			{
				id: 1.9,
				photo: "9",
			},
			{
				id: 1.11,
				photo: "10",
			},
		],
	},
	{
		id: 2,
		time: "Friday, Dec 5",
		location: "London",
		items: [
			{
				id: 2.1,
				photo: "11",
			},
			{
				id: 2.2,
				photo: "12",
			},
			{
				id: 2.3,
				photo: "13",
			},
			{
				id: 2.4,
				photo: "14",
			},
			{
				id: 2.5,
				photo: "15",
			},
		],
	},
	{
		id: 3,
		time: "Monday, Nov 30",
		location: "Dubai",
		items: [
			{
				id: 3.1,
				photo: "16",
			},
			{
				id: 3.2,
				photo: "17",
			},
			{
				id: 3.3,
				photo: "18",
			},
			{
				id: 3.4,
				photo: "19",
			},
			{
				id: 3.5,
				photo: "20",
			},
			{
				id: 3.6,
				photo: "21",
			},
			{
				id: 3.7,
				photo: "22",
			},
			{
				id: 3.8,
				photo: "23",
			},
			{
				id: 3.9,
				photo: "24",
			},
			{
				id: 3.11,
				photo: "1",
			},
			{
				id: 3.12,
				photo: "2",
			},
			{
				id: 3.13,
				photo: "3",
			},
			{
				id: 3.14,
				photo: "4",
			},
			{
				id: 3.15,
				photo: "5",
			},
			{
				id: 3.16,
				photo: "6",
			},
			{
				id: 3.17,
				photo: "7",
			},
		],
	},
];
